import CryptoJS from 'crypto-js';
import { bookingIdHashKey } from './constants';

export function encryptBookingId(bookingId) {
  const key = CryptoJS.enc.Latin1.parse(bookingIdHashKey);
  const plaintext = CryptoJS.enc.Utf8.parse(bookingId);
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const base64Cipher = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  // const encoded = encodeURIComponent(base64Cipher)
  return base64Cipher;
}

export function decryptBookingId(hashedString) {
  try {
    const key = CryptoJS.enc.Latin1.parse(bookingIdHashKey);
    const decryptedBytes = CryptoJS.AES.decrypt(hashedString, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decrypted = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  } catch (err) {
    throw new Error('Error decrypting booking ID: ' + err.message);
  }
}
